module.exports = __webpack_public_path__ + "img/prp_gold.5730f1b7.png";